import { useAuthHeader } from "react-auth-kit";
import { toast } from "react-toastify";
import FormModal from "../../../../components/Modal/FormModal";
import React from "react";
import { send } from "../api/notificationsApi";
import { createDate } from "../utils/notificationDate";
import PushNotificationForm from "./PushNotificationForm";

const initNotification = {
  title: "",
  message: "",
  entityType: "APP_UPDATE",
  entityId: "",
  countryCode: null,
  link: "",
  expiresAt: createDate(5),
};

const SendPushNotificationModal = ({
  onSuccess,
  isOpen,
  onClose,
  notification,
}) => {
  const authHeader = useAuthHeader();

  const handleSubmit = async (formData) => {
    try {
      await send(formData, authHeader());
      toast.success("Notification has been sent!");
      onSuccess();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <>
      <FormModal
        isOpen={isOpen}
        onClose={onClose}
        title="Send Push Notification"
      >
        <PushNotificationForm
          initialData={notification || initNotification}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isNew={true}
        />
      </FormModal>
    </>
  );
};

export default SendPushNotificationModal;
